import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

interface RetailerBusinessCategory {
  businessCategory: keyof typeof IRetailer.BusinessCategory | undefined;
  isOnlineOnlyRetailer: boolean;
  setRetailerBusinessCategory: (retailer: Partial<IRetailer>) => void;
}

export const useZustandRetailerBusinessCategory =
  create<RetailerBusinessCategory>((set) => ({
    businessCategory: undefined,
    isOnlineOnlyRetailer: false,
    setRetailerBusinessCategory: (retailer) => {
      const businessCategory = retailer.business_category;
      const isOnlineOnlyRetailer =
        !!retailer.online_only ||
        businessCategory === IRetailer.BusinessCategory.ONLINE_ONLY;

      set({
        businessCategory,
        isOnlineOnlyRetailer,
      });
    },
  }));

const useRetailerBusinessCategoryControl = () => {
  const { businessCategory, isOnlineOnlyRetailer } = useRetailerStore([
    "businessCategory",
    "isOnlineOnlyRetailer",
  ]);
  return {
    businessCategory,
    isOnlineOnlyRetailer,
  };
};

export const useRetailerBusinessCategory = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandRetailerBusinessCategory();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useRetailerBusinessCategoryControl();
};
